<template>
	<div :style="topologyHeight">
		<editor></editor>
	</div>
</template>

<script type="text/javascript">
import editor from "@/components/TopoComp/editor";
export default {
	name: "TopoEditor",
	components: {editor},
	data() {
		return{
			topologyHeight:{
	          height: window.innerHeight-150  + 'px',
	        },
		}
		
	},
	created() {
	},
	methods:{

	}

};
</script>

<style>


</style>